import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import HomeCardComponent from "../components/home/homeCardComponent";
import VideoModal from "../components/home/videoModal";
import EvdaImage from "../shared/images/evdaImage.svg";
import EvmcImage from "../shared/images/evmcImage.svg";
import VideoImage from "../shared/images/videoImage.svg";
const HomePage =()=>{
    const { t } = useTranslation();
    const [isModalOpen, setIsOpen]=useState(false)
    const cardEvent=()=>{
        setIsOpen(true);
    }

    return(<div className="home-container">
        <Helmet>
          <title>Accueil - Les espérances de vie - Insee</title>
        </Helmet>
        <Link to="EVDA" tabIndex={0}>
          <HomeCardComponent 
            tabIndex={-1}
            cardTitle={t('evda_title')}
            cardImage={
              <img 
                src={EvdaImage}
                alt={t("evda_image_alt") || ""}
                className="img-card-evda"
              />
            }
          ></HomeCardComponent>
        </Link>
        <Link to="EVMC" tabIndex={0}>
            {/* Margin : On aligne le bas des images des cartes */}
            <HomeCardComponent tabIndex={-1} cardTitle={t('evmc_title')} cardImage={<img src={EvmcImage} alt={t("evmc_image_alt") || ""} className="img-card-evmc" />} ></HomeCardComponent>
        </Link>
        {/* Margin : On aligne le bas des images des cartes */}
        <HomeCardComponent 
          tabIndex={0}
          cardTitle={t('ev_question')}
          cardImage={<img src={VideoImage} alt={t("video_image_alt") || ""} className="img-card-video" />} 
          cardEvent={cardEvent}
          cardStyle={{backgroundColor: '#F5F5F7'}}
        ></HomeCardComponent>
        {
          isModalOpen ?
          <VideoModal 
            handleClose={()=>setIsOpen(false)}
          ></VideoModal> :
          undefined
        }

        <br/>

        <div className="texte-presentation-container">
            <div className="texte-presentation">
                <p>
                    {t('ev_resp_ligne_1')}<br/>
                    {t('ev_resp_ligne_2')}<br/>
                    {t('ev_resp_ligne_3')}
                </p>
            </div>
        </div>
    </div>
    )
}

export default HomePage;